/**
 * A dimension line, as drawn on a plan: extension ticks at each end, arrowheads
 * turned inward, and the measurement sitting in a break in the middle.
 *
 * This is the site's section divider. It replaces the eyebrow-over-heading
 * pattern that every section used to open with, so the page reads as a drawing
 * being annotated rather than a stack of identical content blocks.
 */

interface Props {
  /** The text that sits in the break in the line. Omit for a plain dimension. */
  label?: string;
  /** Over cyanotype rather than paper. */
  inverse?: boolean;
  className?: string;
}

export default function DimensionLine({ label, inverse = false, className = '' }: Props) {
  const stroke = inverse ? 'bg-white/30' : 'bg-medline';
  const text = inverse ? 'annot-inverse' : 'annot';
  const arrow = inverse ? 'rgba(255,255,255,0.45)' : '#A9B4B9';

  return (
    <div className={`flex items-center gap-2.5 ${className}`} aria-hidden="true">
      {/* Left extension tick */}
      <span className={`h-2.5 w-px shrink-0 ${stroke}`} />
      <svg width="7" height="7" viewBox="0 0 7 7" className="shrink-0">
        <path d="M0 3.5L7 0v7z" fill={arrow} />
      </svg>
      <span className={`h-px flex-1 origin-left animate-draw-x ${stroke}`} />

      {label && <span className={`${text} shrink-0 whitespace-nowrap`}>{label}</span>}

      <span className={`h-px flex-1 origin-left animate-draw-x ${stroke}`} />
      <svg width="7" height="7" viewBox="0 0 7 7" className="shrink-0">
        <path d="M7 3.5L0 0v7z" fill={arrow} />
      </svg>
      <span className={`h-2.5 w-px shrink-0 ${stroke}`} />
    </div>
  );
}
